import { useTranslation } from "react-i18next";
import type { CustomerClass } from "@hisense/shared";
import { useDataRegion } from "@/app/access";

/**
 * Nhãn công ty của một bản ghi khi đang xem TẤT CẢ công ty (yêu cầu v1.8 mục 1.1: "Any All view must clearly identify the company").
 * Đang xem một công ty thì không hiện — mọi dòng đều của công ty đó. Chữ + khung, không chỉ màu.
 */
export function CompanyTag({ region, className = "" }: { region: CustomerClass | null | undefined; className?: string }) {
  const { t } = useTranslation();
  const viewing = useDataRegion();
  if (!region || viewing) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-xs border border-line px-1 font-mono text-2xs font-semibold uppercase tracking-wide text-ink-soft ${className}`}
      title={t("companySwitch.label") + ": " + t(region === "china" ? "customers.china" : "customers.vietnam")}
    >
      {t(region === "china" ? "companySwitch.cn" : "companySwitch.vn")}
    </span>
  );
}
